import { ArchwizardModule, WizardComponent } from "@achimha/angular-archwizard";
import { Component, EventEmitter, model, Output, signal, ViewChild, ChangeDetectionStrategy, inject } from "@angular/core";
import { BusyButtonDirective } from "rl-common/directives/busy-button.directive";
import { ProgressService } from "rl-common/services/progress.service";
import { TaskConfig, TaskControlGroup } from "rl-common/services/task-config/task-config.models";
import { TaskConfigService } from "rl-common/services/task-config/task-config.service";
import { finalize, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { WorkflowTaskFormComponent } from "../workflow-task-form/workflow-task-form.component";
import { WorkflowTaskGroupFormComponent } from "../workflow-task-group-form/workflow-task-group-form.component";

@Component({
	selector: "rl-workflow-task-modal",
	imports: [WorkflowTaskFormComponent, BusyButtonDirective, ArchwizardModule, WorkflowTaskGroupFormComponent],
	templateUrl: "./workflow-task-modal.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./workflow-task-modal.component.scss",
})
export class WorkflowTaskModalComponent {
	private readonly _taskService = inject(TaskConfigService);
	private readonly _progressService = inject(ProgressService);


	charTypeId = model<number>(0);
	processId = model<number>(0);
	task = model<TaskConfig>(null);
	updatedTask = signal<TaskConfig>(null);

	@Output()
	onComplete = new EventEmitter<[boolean, TaskConfig]>();

	@ViewChild(WizardComponent)
	public wizard: WizardComponent;

	close() {
		const updatedTask = this.updatedTask();
		this.onComplete.next([!!updatedTask, updatedTask]);
	}

	saveOperation(task: TaskConfig) {
		const isCreate = !task.id;
		let save$: Observable<TaskConfig>;
		if (isCreate) {
			save$ = this._taskService.createTaskConfig(task);
		} else {
			save$ = this._taskService.updateTaskConfig(task).pipe(
				map(() => {
					return { ... this.task(), ...task };
				})
			);
		}
		this._progressService.startProgress()
		save$.pipe(
			finalize(() => this._progressService.endProgress())
		).subscribe((task) => {
			this.updatedTask.set(task);
			if (isCreate) {
				this.wizard.goToNextStep();
			} else {
				this.onComplete.next([true, task]);
			}
		});
	}

	saveSet(taskGroup: TaskControlGroup) {
		this._progressService.startProgress()
		this._taskService.createTaskControlGroupConfig(taskGroup).pipe(
			finalize(() => this._progressService.endProgress())
		).subscribe(() => {
			this.onComplete.next([true, this.updatedTask()]);
		});
	}
}
